export interface Project {
  id: string;
  num: string;
  category: string;
  name: string;
  description: string;
  tags: string[];
  leads: string[];
  status: 'active' | 'completed';
  github?: string;
  teamPage?: string;
  img?: string;
}

export const PROJECTS: Project[] = [
  // ── ACTIVE ────────────────────────────────────────────────
  {
    id: 'icarus',
    num: '01',
    category: 'Autonomy · Sensors',
    name: 'ICARUS',
    description: "VLA-based search and rescue robot",
    tags: ['Autonomy', "VLA", 'Motion Planning'],
    leads: ['Manav Karonde', 'Tanay Garg'],
    status: 'active',
    teamPage: 'https://github.com/ECLAIR-Robotics/icarus.git',
  },
  {
    id: 'amaze',
    num: '02',
    category: 'Drone · Obstacle Course',
    name: 'AMAZE',
    description: "Drone missions—Project Hail Mary-style!",
    tags: ['Ariel', 'Simulation', 'Motion Planning'],
    leads: ['Annika Shivam'],
    status: 'active',
    teamPage: 'https://github.com/booleansarebinary/amaze-autonomous-drone.git',
  },
  {
    id: 'eye-tracker',
    num: '03',
    category: 'Computer Vision · Assistive',
    name: 'Eye Tracker',
    description: "Creating a low-cost, wearable video eye-tracking system capable of moving a robotic arm to the user's 3D gaze point, meant to enable assistive technology for individuals with disabilities.",
    tags: ['OpenCV', 'Inverse Kinematics', 'Wearable'],
    leads: ['Dev Patel'],
    status: 'active',
    teamPage: 'https://www.notion.so/invite/d4e646c11b954dc0323659094bb4b41c3d7c56cd',
  },
  {
    id: 'takos',
    num: '04',
    category: 'Bio-Inspired · Hardware',
    name: 'TAKOS',
    description: "The Tactile Appendage Kinematic Octopus System explores biomimicry of octopus features, including dexterous flexible tentacles and independent limb actuation for a variety of robotic applications.",
    tags: ['Biomimicry', 'Kinematics', 'Pneumatics'],
    leads: ['Christopher Elwood', 'Rizky Pratama'],
    status: 'active',
    teamPage: 'https://www.notion.so/TAKOS-Tactile-Appendage-Kinematic-Octopus-System-2a47d39cd23f80e2b943d0dd4f9c8010',
  },
  {
    id: 'hand',
    num: '05',
    category: 'Biotech · Hardware',
    name: 'H.A.N.D.',
    description: "Sleek, Haptic Glove that Teleoperates a Robotic Arm.",
    tags: ['Wearable', 'Hardware', 'Neurotech'],
    leads: ['Ethan Gopez'],
    status: 'active',
    teamPage: 'https://app.notion.com/p/c3dd0549950a8290b76681646eba85f6',
  },
  {
    id: 'argo',
    num: '06',
    category: 'Rover · Hardware',
    name: 'ARGO III',
    description: "Autonomous rover using computer vision to detect obstacles and navigate terrain.",
    tags: ['Sensors', 'Hardware'],
    leads: ['Nithya Challa', 'Shreya Ganti', 'Navya Swali'],
    status: 'active',
    teamPage: 'https://app.notion.com/p/ARGO-III-Landing-Site-3cfc85d2976f8024a0f3f17bc52d9284',
  },
  {
    id: 'beginners-track',
    num: '07',
    category: 'Education · Hardware',
    name: "Beginner's Track",
    description: "A hands-on intro to robotics for freshmen. Students learn to build and program small robots that play soccer, a fun entry point into hardware and embedded systems.",
    tags: ['Education', 'Embedded', 'Hardware'],
    leads: ['Manas Agrawal', 'Yash Karandikar', 'Arnav Joshi'],
    status: 'active',
  },

  // ── COMPLETED ─────────────────────────────────────────────
  {
    id: 'crackle',
    num: '08',
    category: 'Manipulation · AI',
    name: 'C.R.A.C.K.L.E.',
    description: "Emulating DUM-E from Iron Man, a robotic arm that resolves spoken voice commands into dynamically generated execution plans via GPT. Can perform any physically possible task a user requests.",
    tags: ['GPT', 'ROS2', 'Planning'],
    leads: ['Tanay Garg', 'Manav Karonde'],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/crackle',
    teamPage: 'https://befitting-galliform-d9c.notion.site/Crackle-Teamspace-Home-9e32fd2ea0ca4e4695607c16f522433f',
  },
  {
  id: 'auto-car',
    num: '09',
    category: 'Autonomy · NLP',
    name: 'Autonomous Car',
    description: "A fully autonomous RC car with natural language intake and feedback",
    tags: ['NLP', 'OpenCV', 'ROS2', 'Autonomy'],
    leads: ['Marcus Fojas', 'Victor Sanchez'],
    status: 'completed',
    github: 'https://github.com/MaxGamer1312/autonomous-car',
  },
  {
    id: 'mcqueen',
    num: '10',
    category: 'RL · Racing',
    name: 'McQueen',
    description: "Training and fine-tuning reinforcement learning models to navigate a racetrack at speed, working with an AWS DeepRacer autonomous racecar platform.",
    tags: ['Reinforcement Learning', 'Fine-Tuning'],
    leads: ['Suhas Voolla', 'Yash Karandikar'],
    status: 'completed',
    teamPage: 'https://www.notion.so/Radiator-Springs-Home-2d8d0549950a8159a688e2ea12b16581',
  },
  {
    id: 'trace',
    num: '11',
    category: 'Controls · CV',
    name: 'T.R.A.C.E.',
    description: "Tracks and controls the position of a ball on a tilting platform, a basic two-DOF control system that also implements computer vision.",
    tags: [ 'Computer Vision', 'Simulation'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/TRACE',
    teamPage: 'https://www.notion.so/TRACE-18feaa211e138031b1b3cc379fa48413',
  },
  {
    id: 'texel-arts',
    num: '12',
    category: 'ML · Animation',
    name: 'Texel Arts',
    description: "A machine learning system that takes videos and transforms them into animation files applied on given rigs, forming an online library of continuously updated, readily downloadable animations.",
    tags: ['ML', 'Animation', 'Computer Vision'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/Umer-K-PersonOOO/Texel-Art-Media',
    teamPage: 'https://eclair-texel-arts.notion.site/Texel-Arts-19ac77b011c880428939f28b8f068d94',
  },
  {
    id: 'epic',
    num: '13',
    category: 'Controls · Hardware',
    name: 'E.P.I.C.',
    description: "An expressive self-balancing robot exploring PID control, computer vision, sensor interfacing, and custom PCB design. Features an LCD face that adjusts expressions based on stability.",
    tags: ['PID', 'ESP32', 'IMU'],
    leads: [],
    status: 'completed',
    teamPage: 'https://docs.google.com/document/d/1gbFuBh5Rj6CCqdpV75lZLSzmt4x5dXSdN6iSoQHVaYI/edit',
  },
  {
    id: 'duckduckflow',
    num: '14',
    category: 'IoT · Environmental',
    name: 'DuckDuckFlow',
    description: "A wireless, solar-powered water level monitoring device for flood-prone zones in the Hill Country. Provides real-time early flood detection to help emergency services respond faster.",
    tags: ['IoT', 'Solar', 'Sensors'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/duck-duck-flow',
    teamPage: 'https://www.notion.so/DuckDuckHome-22fd0549950a8075bed4d31c18fd877b',
  },
  {
    id: 'pcr',
    num: '15',
    category: 'Biotech · Automation',
    name: 'P.C.R.',
    description: "Automating PCR, a medical technique used to duplicate DNA. All individual components were built and integrated, culminating in a published research paper.",
    tags: ['Automation', 'Biotech', 'Research'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/PCR_Automation',
    teamPage: 'https://docs.google.com/spreadsheets/d/1qEEfA078V_SaOaCuu-pih-EUJhn9BdbRNVKUYMlfKlY/edit',
  },
  {
    id: 'chess-teacher',
    num: '16',
    category: 'CV · Robotics',
    name: 'Chess Teacher',
    description: "A robot that plays chess and teaches the player how to improve. Uses overhead computer vision for board state, and an in-house chess engine for comprehensive positional understanding.",
    tags: ['Computer Vision', 'Education'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/Chess_Teacher',
    teamPage: 'https://docs.google.com/spreadsheets/d/1CbTH5hqcQgmXZnDkoqhe9yYVnaWjdlhSyqxfz_0mcEA/edit',
  },
  {
    id: 'autonomous-drone',
    num: '17',
    category: 'Autonomy · Aerial',
    name: 'Autonomous Drone',
    description: "A hexacopter drone programmed to navigate and perform tasks autonomously using a suite of cameras and sensors for indoor mapping, trash pickup, and search missions.",
    tags: ['ROS', 'Autonomy', 'Aerial'],
    leads: [],
    status: 'completed',
    teamPage: 'https://docs.google.com/spreadsheets/d/1HXZt8AaNJ8NgtD4zdfVyAx9iu88J-shJCg4XmMV2MSs/edit',
  },
  {
    id: 'music-mood',
    num: '18',
    category: 'NLP · ML',
    name: 'Music Mood',
    description: "Fine-tuned a large language model to associate emotions with songs via lyrics, then used it to analyze Spotify profiles and playlists for emotional content.",
    tags: ['NLP', 'GPT', 'Fine-Tuning'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/Song-Analysis',
    teamPage: 'https://docs.google.com/spreadsheets/d/1X8J35_nY-nvYd4q41Xf4_2WzTLX5uL0LTaCeWgZsZ2c/edit',
  },
  {
    id: 'robotic-arm',
    num: '19',
    category: 'Kinematics · Hardware',
    name: 'Robotic Arm',
    description: "Implementing inverse kinematics and advanced software features on a robotic arm to deepen understanding of arm construction and motion planning.",
    tags: ['Inverse Kinematics', 'Motion Planning', 'Hardware'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/RoboticArm-',
  },
  {
    id: 'fitness-tracker',
    num: '20',
    category: 'ML · Wearable',
    name: 'Fitness Tracker',
    description: "A smart fitness band that tracks reps and measures form using IMU sensor data and an ML model. It provides real-time suggestions based on common form errors.",
    tags: ['IMU', 'ML', 'Wearable', 'Health'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/fitness-tracker',
    teamPage: 'https://docs.google.com/spreadsheets/d/1X8J35_nY-nvYd4q41Xf4_2WzTLX5uL0LTaCeWgZsZ2c/edit',
  },
  {
    id: 'smart-mirror',
    num: '21',
    category: 'HCI · Hardware',
    name: 'Smart Mirror',
    description: "A modified Samsung infrared TV converted into a functional smart mirror capable of interacting with a user and performing basic utility functions.",
    tags: ['HCI', 'Hardware'],
    leads: [],
    status: 'completed',
    github: 'https://github.com/ECLAIR-Robotics/Smart-Mirror',
    teamPage: 'https://docs.google.com/spreadsheets/d/1cCVkAxT6YRqcerKprb5HxVsnR_jYmP8Ai7Nvbnz0M0I/edit',
  },
  {
    id: 'hydroponics',
    num: '22',
    category: 'Automation · AgTech',
    name: 'Hydroponics',
    description: "An automated hydroponic garden with autonomous nutrient delivery, environmental monitoring, and growth tracking.",
    tags: ['Automation', 'AgTech', 'Sensors'],
    leads: [],
    status: 'completed',
    teamPage: 'https://www.notion.so/Autonomous-Hydroponics-de7db5da18214e42a170f000432b0deb',
  },
];